import { Box, Color, P, PlainLink } from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";
import { useRouter } from "next/router";

import { getBankAccountDataUrl, isRoleAndEnvironment } from "src/common/config";
import { TrackingEvent } from "src/common/trackingEvents";
import { useSegment } from "src/technical-integrations/segment/useSegment";
import { ConfigurationEnvironment } from "src/common/environments";
import { sendGA4Event } from "src/technical-integrations/third-party-tracking/google-analytics";

const BankAccountDataBanner = () => {
  const { sendEvent } = useSegment();
  const router = useRouter();

  const bankAccountDataUrl = getBankAccountDataUrl({
    path: "login",
    utmCampaign: "signin_page",
  });
  const isSandboxProduction = isRoleAndEnvironment(
    ConfigurationEnvironment.SandboxProduction
  );

  if (isSandboxProduction) return null;
  return (
    <Box
      borderRadius={0.25}
      borderColor={Color.Pebble_400}
      borderWidth={1}
      bg={Color.Pebble_100}
      gutterH={1}
      gutterV={1}
      spaceAbove={2}
    >
      <P size={2}>
        <Trans id="sign-in-page.looking-for-bad">
          Looking for <b>Bank Account Data</b> (formerly Nordigen)?
        </Trans>{" "}
        <PlainLink
          data-testid="bad-dashboard-sign-in"
          href={bankAccountDataUrl}
          decoration="underline"
          css={{ fontWeight: 600 }}
          onClick={() => {
            sendEvent(TrackingEvent.BANK_ACCOUNT_DATA_LOG_IN_CLICKED, {
              page: router.pathname,
            });
            sendGA4Event("page_view", {
              page_title: "Bank Account Data - Login",
              page_location: bankAccountDataUrl,
            });
          }}
        >
          <Trans id="Sign in"> Sign in </Trans>
        </PlainLink>
      </P>
    </Box>
  );
};

export default BankAccountDataBanner;
